export default {
  sid_signals_table: 7,
  insider_transactions_summary: 7,
  stock_quarterly_data: 10,
  ops_opd: 6,
  highs_and_lows_table: 1,
  supply_and_demand_alerts_table: 9,
  supply_and_demand_table: 10,
  trend_strategy_signals_table: 11
};
